import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const ItemWebinar = (props) => {

    const [state, setState] = useState({
        data: props.data,
        loader: true
    })

    return (
        <div className="item-webinarses">
            <div className="pic">
                <img src={state.data.cover_image} />
            </div>
            <h4>{state.data.title}</h4>
            <div className="date">
                <div className="date-details">
                    <span>تاریخ شروع : </span>
                    <strong>{state.data.string_starttime}</strong>
                </div>
                <div className="date-details">
                    <span>زمان برگزاری : </span>
                    <strong>{state.data.string_eventtime}</strong>
                </div>
            </div>
            <div className="date-details">
                <span>درباره وبینار :</span>
                <strong>{state.data.description}</strong>
            </div>
            <div className="list-tags">
                {state.data.tags.map(item=>
                    <span>{item.name}</span>
                )}
            </div>
            
            <Link to={`/myWebinars/detailes/${state.data.id}`} className="details-link">مشاهده جزییات</Link>

        </div>
    );
}

export default ItemWebinar;